import { LocalDate } from '@js-joda/core';

import { VisitAndAppointmentPrescriptionOnlyView } from '@dreryk/egabinet-visit-frontend-api';

import { protectFeature } from '~libs.shared.system';

import { CancelAppointmentButton } from '../../../appointment/table/cells/OptionsCell/CancelAppointmentButton';
import { ContinueVisitButton } from '../../../appointment/table/cells/OptionsCell/ContinueVisitButton';
import { ShowVisitButton } from '../../../appointment/table/cells/OptionsCell/ShowVisitButton';
import { StartVisitButton } from '../../../appointment/table/cells/OptionsCell/StartVisitButton';
import { prescriptionVisitsTranslationKeys } from '../../../translations';

type PrescriptionVisitOptionsCellProps = {
   readonly bean: VisitAndAppointmentPrescriptionOnlyView;
   readonly refetchPrescriptionVisits: VoidFunction;
};

export const PrescriptionVisitOptionsCell = (props: PrescriptionVisitOptionsCellProps): JSX.Element | null => {
   const appointmentId = props.bean.appointmentId.asNumber();
   const patientId = props.bean.patientId.asNumber();
   const visitId = props.bean.visitId?.asNumber();
   const isFutureVisit = props.bean.appointmentDate.isAfter(LocalDate.now());

   switch (props.bean.status) {
      case 'REGISTERED':
         return protectFeature(
            'searchingVisitOperations',
            <StartVisitButton
               appointmentId={appointmentId}
               disabled={isFutureVisit || !props.bean.ownedByCurrentUser}
               patientId={patientId}
               onVisitAlreadyStartedFault={props.refetchPrescriptionVisits}
               onAppointmentAlreadyCancelledFault={props.refetchPrescriptionVisits}
               visitType={'prescription'}
            />,
            protectFeature(
               'creatingAppointments',
               <CancelAppointmentButton
                  appointmentId={appointmentId}
                  cancellable={props.bean.cancellable}
                  refetchAppointments={props.refetchPrescriptionVisits}
               />,
               null
            )
         );
      case 'IN_PROGRESS':
      case 'FINISHED_NOT_APPROVED':
         return protectFeature(
            'searchingVisitOperations',
            <ContinueVisitButton
               appointmentId={appointmentId}
               visitId={visitId!}
               patientId={patientId}
               disabled={!props.bean.ownedByCurrentUser}
               visitType={'prescription'}
            />,
            null
         );
      case 'FINISHED_APPROVED':
         return protectFeature(
            'searchingMedicalData',
            <ShowVisitButton
               visitId={visitId}
               patientId={patientId}
               backActionLabel={prescriptionVisitsTranslationKeys.goBackToPrescriptionVisits}
            />,
            null
         );
      case 'CANCELLED':
      default:
         return null;
   }
};
